<div class="content-box-wrapper">
	<div class="content-box form-wrapper">
		<span
			id="optimize-registration"
			appOptimizeListener
			(changeEvent)="enableOptimize($event, 'optimize-registration')">
		</span>
		<ng-container *ngIf="!accountCreated && verificationAttemptCount === 1">
			<div class="error error-color align-center">
				<p [translate]="'registration.create-account.secondary-verification-error-case-1'"></p>
			</div>
		</ng-container>
		<ng-container *ngIf="accountCreated">
			<h2 class="align-center section-heading" [translate]="'registration.create-account.check-email'">
				Check your email!
			</h2>
			<div class="align-center mt-3">
				<span [translate]="'registration.create-account.please-check'"
					>We have sent you an email to confirm your account. If you do not see the email in a few minutes, check your
					spam folder.</span
				>
			</div>
			<div class="center">
				<button
					class="button button-medium mt-3"
					mat-button
					appEheAnalytics
					[routerLink]="['/login']"
					[data]="{
						pageUrl: '/registration',
						redirectedTo: '/login',
						componentName: 'create-account',
						id: 'Return to Sign In',
						placement: 'Registration - Back Button'
					}">
					<span [translate]="'registration.create-account.back-btn'">Back</span>
				</button>
			</div>
		</ng-container>
		<form [formGroup]="createAccountForm" *ngIf="!accountCreated">
			<ng-container *ngIf="verificationAttemptCount >= 2 && !ssnRequired">
				<ng-container *ngIf="verificationAttemptCount === 2">
					<div class="error error-color align-center">
						<p [translate]="'registration.create-account.secondary-verification-error-case-2'"></p>
					</div>
				</ng-container>
				<ng-container *ngIf="verificationAttemptCount > 2">
					<div class="error error-color align-center">
						<span [translate]="'registration.create-account.secondary-verification-error-case-1'"></span>
					</div>
				</ng-container>
				<div class="row" *ngIf="!employeeIdRequired">
					<div class="col-12">
						<mat-form-field class="form-group">
							<mat-label>{{ 'registration.code-verification.form.ssn' | translate }}</mat-label>
							<input
								matInput
								formControlName="ssn"
								type="text"
								appMaskSSN
								[ssnFormGroup]="createAccountForm"
								[ssnControlName]="'ssn'"
								[clearValue]="clearValue"
								[ShowSSNValue]="showhideSSNVal" />
							<i class="toggle-ssn {{ showhideSSNVal ? 'show' : 'hide' }}" (click)="showHideSSN()">
								<svg class="icon" height="512" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
									<path
										d="M1023.997 511.831c0 99.79-211.129 312.67-511.999 312.67C218.787 824.501 0 615.125 0 511.831c0-103.279 219.73-312.334 511.999-312.334 303.234 0.001 512.071 209.057 511.999 312.335L1023.998 511.831zM512.45 256.529C376.184 256.529 265.72 370.913 265.72 512c0 141.089 110.463 255.471 246.729 255.471 136.307 0 246.774-114.383 246.774-255.471C759.223 370.913 648.756 256.529 512.45 256.529L512.45 256.529zM511.999 348.901c-86.778 0-157.126 72.827-157.126 162.673 0 89.836 70.348 162.677 157.126 162.677s157.097-72.841 157.097-162.677C669.096 421.727 598.776 348.901 511.999 348.901L511.999 348.901z" />
								</svg>
							</i>
							<mat-error>
								<app-error-message [control]="'ssn'"></app-error-message>
							</mat-error>
						</mat-form-field>
					</div>
				</div>
				<div class="row" *ngIf="employeeIdRequired">
					<div class="col-12">
						<mat-form-field class="form-group">
							<mat-label>{{ 'registration.code-verification.form.employeeID' | translate }}</mat-label>
							<input matInput formControlName="employeeID" type="text" />
							<mat-error>
								<app-error-message [control]="'employeeID'"></app-error-message>
							</mat-error>
						</mat-form-field>
					</div>
				</div>
			</ng-container>
			<ng-container
				*ngIf="
					createAccountForm.controls['employer'].errors?.['invalidEmployer'] &&
					createAccountForm.controls['employer'].touched
				">
				<mat-error class="text-center pb-2"
					>Please enter your full name as it appears in employer records. For employer, begin typing and then select
					directly from dropdown menu.</mat-error
				>
			</ng-container>
			<h2 class="align-center section-heading" [translate]="'registration.create-account.form.title'">
				Create My Account
			</h2>
			<div class="row create-account-entry">
				<div class="col-12">
					<mat-form-field class="form-group">
						<mat-label>{{ 'registration.create-account.form.first-name' | translate }}</mat-label>
						<input matInput formControlName="firstName" />
						<mat-error>
							<app-error-message [control]="'firstName'"></app-error-message>
						</mat-error>
					</mat-form-field>
				</div>
			</div>

			<div class="row create-account-entry">
				<div class="col-12">
					<mat-form-field class="form-group">
						<mat-label>{{ 'registration.create-account.form.last-name' | translate }}</mat-label>
						<input matInput formControlName="lastName" />
						<mat-error>
							<app-error-message [control]="'lastName'"></app-error-message>
						</mat-error>
					</mat-form-field>
				</div>
			</div>
			<div class="dob-field create-account-entry">
				<mat-form-field class="form-group">
					<mat-label>{{ 'registration.create-account.form.dob' | translate }}</mat-label>
					<input matInput formControlName="dateOfBirth" (focusout)="changeHint()" [imask]="dobMask.iMaskArgs" />
					<mat-hint *ngIf="showHint">{{ dateFormat }}</mat-hint>
					<mat-error>
						<app-error-message control="dateOfBirth"></app-error-message>
					</mat-error>
				</mat-form-field>
			</div>
			<div class="row create-account-entry">
				<div class="col-12">
					<mat-form-field class="form-group">
						<mat-label>{{ 'registration.create-account.form.employer' | translate }}</mat-label>
						<input matInput formControlName="employer" [matAutocomplete]="auto" />
						<mat-autocomplete #auto="matAutocomplete" [displayWith]="getEmployerDisplayName">
							<mat-option *ngFor="let option of filteredOptions | async" [value]="option">
								{{ option.name }}
							</mat-option>
						</mat-autocomplete>
						<i class="fas fa-circle-notch align-loader-right" *ngIf="showTypeAheadLoader"></i>
						<mat-error>
							<app-error-message [control]="'employer'"></app-error-message>
						</mat-error>
					</mat-form-field>
				</div>
			</div>
			<div class="row create-account-entry" *ngIf="ssnRequired">
				<div class="col-12">
					<mat-form-field class="form-group">
						<mat-label>{{ 'registration.create-account.form.social-security-number' | translate }}</mat-label>
						<input
							matInput
							formControlName="ssn"
							type="text"
							appMaskSSN
							[ssnFormGroup]="createAccountForm"
							[ssnControlName]="'ssn'"
							[clearValue]="clearValue"
							[ShowSSNValue]="showhideSSNVal" />
						<i class="toggle-ssn {{ showhideSSNVal ? 'show' : 'hide' }}" (click)="showHideSSN()">
							<svg class="icon" height="512" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
								<path
									d="M1023.997 511.831c0 99.79-211.129 312.67-511.999 312.67C218.787 824.501 0 615.125 0 511.831c0-103.279 219.73-312.334 511.999-312.334 303.234 0.001 512.071 209.057 511.999 312.335L1023.998 511.831zM512.45 256.529C376.184 256.529 265.72 370.913 265.72 512c0 141.089 110.463 255.471 246.729 255.471 136.307 0 246.774-114.383 246.774-255.471C759.223 370.913 648.756 256.529 512.45 256.529L512.45 256.529zM511.999 348.901c-86.778 0-157.126 72.827-157.126 162.673 0 89.836 70.348 162.677 157.126 162.677s157.097-72.841 157.097-162.677C669.096 421.727 598.776 348.901 511.999 348.901L511.999 348.901z" />
							</svg>
						</i>
						<mat-error>
							<app-error-message [control]="'ssn'"></app-error-message>
						</mat-error>
					</mat-form-field>
				</div>
			</div>
			<div class="row create-account-entry">
				<div class="col-12">
					<mat-form-field class="form-group">
						<mat-label>{{ 'registration.create-account.form.email' | translate }}</mat-label>
						<input matInput formControlName="email" />
						<mat-error>
							<app-error-message [control]="'email'"></app-error-message>
						</mat-error>
					</mat-form-field>
				</div>
			</div>
			<div id="cellPhoneDiv" class="row create-account-entry" *ngIf="!hideCellPhone">
				<div class="col-12">
					<mat-form-field class="form-group">
						<mat-label>{{ 'registration.create-account.form.cell' | translate }}</mat-label>
						<input matInput formControlName="cellPhone" [imask]="phoneMask.iMaskArgs" />
						<mat-error>
							<app-error-message [control]="'cellPhone'"></app-error-message>
						</mat-error>
					</mat-form-field>
				</div>
			</div>
			<div class="row create-account-entry">
				<div class="col-12">
					<div class="privacy">
						<mat-checkbox formControlName="privacy">
								<span [translate]="'registration.create-account.form.privacy.accept-text'">I consent EHE
									Health's</span>
								<a [translate]="'registration.create-account.form.privacy.terms-text'"
									(click)="navToLink('/terms')">
									Terms and Conditions & Health Coaching
								</a>
								<span [translate]="'registration.create-account.form.privacy.and-text'">, and </span>
								<a [translate]="'registration.create-account.form.privacy.privacy-policy-text'"
									(click)="navToLink('/privacy-policy')">
									Data Privacy Policy
								</a>
						</mat-checkbox>
						<mat-error>
							<app-error-message [control]="'privacy'"></app-error-message>
						</mat-error>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-12">
					<div class="center">
						<button
							class="button button-medium"
							mat-button
							appEheAnalytics
							[data]="analyticsData"
							(click)="createAccount()">
							<span [translate]="'registration.create-account.form.submit-button'">CREATE ACCOUNT</span>
						</button>
					</div>
				</div>
			</div>
			<div class="links small-text create-account-entry">
				<div class="center">
					<strong>
						<a
							appEheAnalytics
							tabindex="-1"
							(keypress)="redirect()"
							(click)="redirect()"
							[data]="{
								pageUrl: '/registration',
								redirectedTo: '/login',
								componentName: 'create-account',
								id: 'Return to Sign In',
								placement: 'Registration create account'
							}">
							Return to Sign In
						</a>
					</strong>
				</div>
			</div>
		</form>
	</div>
</div>
